import { createAwrApp } from '@/awr';
import SignIn from '@/modules/auth/SignIn.vue';
import { h } from 'vue';

const app = createAwrApp({
  setup() {
    return () => h(SignIn);
  },
});
app.mount('#app');
